var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("a-spin", { attrs: { spinning: _vm.isLoading } }, [
        _c(
          "div",
          { staticClass: "work-content" },
          [
            _c("Components", {
              on: {
                handleClickItem: _vm.onAddItem,
                startDragItem: _vm.onStartDragItem,
                endDragItem: _vm.onEndDragItem,
              },
            }),
            _vm._v(" "),
            !_vm.isLoading
              ? _c("Phone", {
                  ref: "phone",
                  attrs: {
                    data: _vm.data,
                    selectedIndex: _vm.selectedIndex,
                    draggingNewType: _vm.draggingNewType,
                  },
                  on: {
                    onEditer: _vm.onEditer,
                    onDeleleItem: _vm.onDeleleItem,
                    onDropNewItem: _vm.onDropNewItem,
                    onCopyItem: _vm.onCopyItem,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "editor-panel" },
                  [
                    _c(
                      "div",
                      { staticClass: "editor-actions" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", loading: _vm.isLoading },
                            on: { click: _vm.onFormSubmit },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("Editor", {
                      attrs: {
                        defaultData: _vm.defaultData,
                        data: _vm.data,
                        selectedIndex: _vm.selectedIndex,
                        curItem: _vm.curItem,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }